import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { IonicModule, ModalController, NavController } from '@ionic/angular';
import { TranslocoModule } from '@jsverse/transloco';
import { Country } from '@app/core/interfaces/country.interface';
import { CountryService } from '@app/core/services/country.service';
import { RoundedPillButtonComponent } from '@app/core/components/buttons/pill/pill-button.component';

@Component({
  standalone: true,
  selector: 'ups-country-modal',
  templateUrl: './country-modal.component.html',
  styleUrls: ['./country-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    IonicModule,
    TranslocoModule,
    RoundedPillButtonComponent
  ],
})
export class CountryModalComponent implements OnInit {

  public readonly activeCountry: Country = this.countryService.activeCountry();
  public readonly lang: { text: string, value: string }[] = [];
  public activeLang: number = 0;

  constructor(
    public readonly countryService: CountryService,
    protected readonly navCtrl: NavController,
    protected readonly modalCtrl: ModalController
  ) { }

  public ngOnInit(): void{
    this.activeCountry.langCodes.forEach((l: any, i: number) => {
      this.lang.push({ text: l.replace('CH', '中').replace('ZH', '中').toUpperCase(), value: l });

      if (l === this.countryService.activeLanguage()) this.activeLang = i;
    });
  }

  public dismiss(): void{ this.modalCtrl.dismiss(); }

  public selectLanguage({ value, idx }: { value: string, idx: number }): void{
    if (idx !== this.activeLang) {
      this.activeLang = idx;
      this.countryService.setActiveLanguage(value);
    }
  }

  public selectCountry(c: Country): void{
    if (c.code !== this.countryService.activeCountry().code) {
      this.countryService.setActiveCountry(c);

      this.dismiss();
      this.navCtrl.navigateRoot('/home', { skipLocationChange: true }).then(() => this.navCtrl.navigateRoot('/', { replaceUrl: true }));
    }
  }
}
